// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jm0BF","top":"styles_top__1GyEY","left":"styles_left__10n-R","description":"styles_description__XKcKe"};